import React from 'react'

function Third() {
  return (
    <section className="third">
    <div className="container">
        <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
            <div className="left-col">
                <img src="/logo.png" alt="second img"/>
            </div>
            <div className="right-col">
                <p className="text">
                    Για όσους αναζητούν οπτική απόλαυση, το Crazy Monkey Slot προσφέρει συναρπαστικά σύμβολα παιχνιδιού που κάνουν κάθε περιστροφή πραγματικά διασκεδαστική. 
                    Το παιχνίδι διαθέτει έντονα χρώματα που ζωντανεύουν κάθε στοιχείο του περιβάλλοντος χρήστη, δημιουργώντας μια πραγματικά γιορτινή ατμόσφαιρα. 
                    Αυτό το δωρεάν κοινωνικό καζίνο σας επιτρέπει να νιώσετε την εμπειρία ενός πραγματικού καζίνο, χωρίς να διακινδυνεύσετε δικά σας χρήματα.
                </p>
            </div>
        </div>
        <p className="text text-md">
            Το Crazy Monkey Slot είναι μια ολοκληρωμένη εμπειρία που θα σας αφήσει αξέχαστες εντυπώσεις. 
            Βυθιστείτε στον μαγευτικό κόσμο του κοινωνικού καζίνο και απολαύστε κάθε λεπτό του παιχνιδιού. 
            Με υποστήριξη για κινητές συσκευές και υπολογιστές, το παιχνίδι είναι πάντα προσβάσιμο, επιτρέποντάς σας να το απολαμβάνετε οποιαδήποτε στιγμή. 
            Το Crazy Monkey Slot είναι μια δωρεάν μορφή ψυχαγωγίας που προσφέρει χαρά και απόλαυση, χωρίς να χρειάζεται να φύγετε από το σπίτι σας.
        </p>
    </div>
</section>

  )
}

export default Third